<app-pfi-dropdown [initialProformaId]="initialProformaId" (onPfiChange)="setNewPfi($event)"></app-pfi-dropdown>

<form (ngSubmit)="onSubmit()" *ngIf="pfi" [formGroup]="proformaForm" class="form-wrapper value-sheet-form">

  <div *ngIf="saveErrorMessage || serverValidationErrors.length" class="validation-summary" role="alert" aria-live="assertive">
    <div class="validation-summary__title">Unable to save value sheet</div>
    <p *ngIf="saveErrorMessage">{{ saveErrorMessage }}</p>
    <ul *ngIf="serverValidationErrors.length">
      <li *ngFor="let error of serverValidationErrors">
        <strong>{{ error.field }}</strong>: {{ error.message }}
      </li>
    </ul>
  </div>

  <div class="value-sheet document-sheet">
    <div class="doc-header mat-elevation-z1">
      <div class="doc-header__left">
        <div class="header-overline">Proforma workspace</div>
        <div class="doc-heading">
          {{ proformaForm.get('accountNo')?.value }} - {{ proformaForm.get('pfiId')?.value }}
        </div>
        <div class="doc-subheading">{{ proformaForm.get('companyName')?.value }}</div>
      </div>
      <div class="doc-header__right">
        <div class="doc-brand-box"><mat-icon>receipt_long</mat-icon> Value Sheet</div>
      </div>
    </div>

    <div class="doc-option-row">
      <mat-checkbox (change)="onToggleFreightToBeConfirmed()" [formControl]="freightToBeConfirmedControl" color="primary">
        Freight To Be Confirmed
      </mat-checkbox>
    </div>

    <div class="summary-layout">
      <div class="panel-block summary-panel mat-elevation-z1">
        <div class="panel-title panel-title--padded">Warehouse Summary</div>
        <table class="sheet-table">
          <thead>
            <tr>
              <th class="sticky-col" scope="col">Warehouse</th>
              <th scope="col">Lines</th>
              <th scope="col">Goods</th>
              <th scope="col">Gross Profit</th>
              <th scope="col">Handling</th>
              <th scope="col">Inland</th>
              <th scope="col">IWD</th>
              <th scope="col">Export</th>
              <th scope="col">Total</th>
            </tr>
          </thead>
          <tbody>
              <tr *ngFor="let row of vsSplitRows" [formGroup]="row">
              <td class="sticky-col" data-label="Warehouse">
                {{ row.get('warehouse.region')?.value }}
                <span class="warehouse-commodity" *ngIf="row.get('commodity.name')?.value">{{ row.get('commodity.name')?.value }}</span>
              </td>
              <td data-label="Lines">{{ row.get('warehouseLineCount')?.value }}</td>
              <td class="currency-value" data-label="Goods">{{ currencySymbol }} {{ row.get('warehouseGoodsValue')?.value | number:'1.2-2' }}</td>
              <td data-label="Gross Profit">{{ (row.get('warehouseProfitValue')?.value || 0) * 100 | number:'1.1-1' }}%</td>
              <td class="currency-value" data-label="Handling">{{ currencySymbol }} {{ row.get('warehouseHandlingValue')?.value | number:'1.2-2' }}</td>
              <td class="currency-value" data-label="Inland">{{ currencySymbol }} {{ row.get('warehouseInlandValue')?.value | number:'1.2-2' }}</td>
              <td class="currency-value" data-label="IWD">{{ currencySymbol }} {{ getIwdCostForRow(row) | number:'1.2-2' }}</td>
              <td data-label="Export">
                <mat-form-field class="mini-field currency-field">
                  <span matPrefix>{{ currencySymbol }}&nbsp;</span>
                  <input formControlName="warehouseExportValue" matInput step="0.01" type="number">
                </mat-form-field>
              </td>
              <td data-label="Total">
                <mat-form-field class="mini-field currency-field">
                  <span matPrefix>{{ currencySymbol }}&nbsp;</span>
                  <input formControlName="warehouseTotalValue" matInput step="0.01" type="number">
                </mat-form-field>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td class="sticky-col">Not Available</td>
              <td colspan="8">{{ proformaForm.get('notAvailable')?.value }}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>

    <div class="two-column-layout details-layout">
      <div class="panel-block iwd-panel mat-elevation-z1" formGroupName="vsIwd">
        <div class="panel-title">IWD</div>
        <div *ngIf="iwdClearedNotice" class="iwd-notice" role="status" aria-live="polite">
          <mat-icon>info</mat-icon>
          <span>{{ iwdClearedNotice }}</span>
          <button type="button" mat-icon-button aria-label="Dismiss" (click)="iwdClearedNotice = ''">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div class="iwd-field-group">
          <label>From</label>
          <mat-form-field>
            <mat-select [formControlName]="'leavingFrom'" [compareWith]="compareWarehouses">
              <mat-option *ngFor="let option of iwdWarehouseList" [value]="option">
                {{ option.region }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="iwd-field-group">
          <label>To</label>
          <mat-form-field>
            <input matInput [value]="proformaForm.get('vsAdditionalDetails.leavingFrom')?.value?.region || 'Select a warehouse in Additional Details'" disabled>
          </mat-form-field>
        </div>
        <div class="iwd-field-group">
          <label>Cost</label>
          <mat-form-field class="currency-field">
            <span matPrefix>{{ currencySymbol }}&nbsp;</span>
            <input [formControlName]="'cost'" matInput step="0.01" type="number">
          </mat-form-field>
        </div>
      </div>

      <div class="freight-column">
        <div *ngIf="vsPredictions.length" class="panel-block mat-elevation-z1">
          <div class="panel-title">Predictions/Estimates</div>
          <div class="predictions-table-wrap">
            <table class="predictions-table">
              <thead>
                <tr>
                  <th scope="col">Freight Method</th>
                  <th *ngFor="let warehouse of uniqueWarehouses" scope="col">{{ warehouse.name }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of vsPredictionRows">
                  <td>{{ row.get('method')?.value }}</td>
                  <td *ngFor="let warehouse of uniqueWarehouses" class="currency-value">
                    {{ currencySymbol }} {{ computePrediction(row, warehouse.id) | number:'1.2-2' }}
                    <span class="prediction-percentage">({{ getPredictionPercentage(row, warehouse.id) | number:'1.1-2' }}%)</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="panel-block mat-elevation-z1" formGroupName="vsBreakdown">
          <div class="panel-title">Freight Breakdown</div>
          <div *ngFor="let warning of costWarnings" class="cost-warning" role="status" aria-live="polite">
            <mat-icon>warning</mat-icon>
            <span>{{ warning }}</span>
          </div>

          <table class="detail-table">
          <tr *ngFor="let row of vsBreakdownFields">
            <td class="detail-label">
              <div>{{ row.label }}</div>
              <mat-checkbox [formControlName]="row.controlName + 'Markup'" color="primary">Markup 10%</mat-checkbox>
            </td>
            <td class="detail-field">
              <div class="charge-inputs" [class.has-percentage]="row.supportsPercentage">
                <mat-form-field *ngIf="row.supportsPercentage" class="percentage-field">
                  <input [formControlName]="row.controlName + 'Percentage'" matInput type="number">
                  <span matSuffix>%</span>
                </mat-form-field>
                <mat-form-field class="full-width-field currency-field">
                  <span matPrefix>{{ currencySymbol }}&nbsp;</span>
                  <input [formControlName]="row.controlName" matInput step="0.01" [type]="row.type">
                </mat-form-field>
                <div class="markup-result" *ngIf="proformaForm.get('vsBreakdown.' + row.controlName + 'Markup')?.value" aria-live="polite">
                  <span>With 10% markup</span>
                  <strong>{{ currencySymbol }} {{ getMarkedUpValue(proformaForm.get('vsBreakdown.' + row.controlName)?.value) | number:'1.2-2' }}</strong>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="2" class="detail-header">Additional Charges</td>
          </tr>
          <ng-container formArrayName="additionalCharges">
            <ng-container *ngFor="let charge of additionalCharges.controls; let i = index" [formGroupName]="i">
              <tr class="additional-charge-row">
                <td class="detail-label">
                  <mat-form-field class="full-width-field">
                    <input formControlName="description" matInput placeholder="Charge Description">
                  </mat-form-field>
                </td>
                <td class="detail-field">
                  <mat-form-field class="full-width-field currency-field">
                    <span matPrefix>{{ currencySymbol }}&nbsp;</span>
                    <input formControlName="chargeValue" matInput step="0.01" type="number">
                  </mat-form-field>
                </td>
              </tr>
              <tr class="additional-charge-actions">
                <td></td>
                <td>
                  <div class="additional-charge-actions__content">
                    <div class="markup-result" *ngIf="charge.get('markUp')?.value" aria-live="polite">
                      <span>With 10% markup</span>
                      <strong>{{ currencySymbol }} {{ getMarkedUpValue(charge.get('chargeValue')?.value) | number:'1.2-2' }}</strong>
                    </div>
                    <mat-checkbox formControlName="markUp" color="primary">Markup 10%</mat-checkbox>
                    <button mat-icon-button (click)="removeCharge(i)" [disabled]="freightToBeConfirmedControl.value" matTooltip="Remove charge" type="button">
                      <mat-icon>delete_outline</mat-icon>
                    </button>
                  </div>
                </td>
              </tr>
            </ng-container>
          </ng-container>
          <tr>
            <td colspan="2">
              <button mat-stroked-button color="primary" class="add-charge-btn" type="button" (click)="addCharge()" [disabled]="freightToBeConfirmedControl.value">
                <mat-icon>add</mat-icon> Add another charge
              </button>
            </td>
          </tr>
          <tr>
            <td class="detail-label">Total</td>
            <td class="detail-field">
              <mat-form-field class="full-width-field currency-field">
                <span matPrefix>{{ currencySymbol }}&nbsp;</span>
                <input formControlName="total" matInput step="0.01" type="number" readonly>
              </mat-form-field>
            </td>
          </tr>
          </table>
        </div>
      </div>

      <div class="panel-block mat-elevation-z1" formGroupName="vsAdditionalDetails">
        <div class="panel-title">Additional Details</div>

        <div class="toggle-row">
          <mat-checkbox (change)="onToggleDatesToBeSet()" [formControlName]="'datesToBeSet'" color="primary">
            Dates To Be Set
          </mat-checkbox>
        </div>

        <table class="detail-table">
          <ng-container *ngFor="let row of vsAdditionalDetailsFields">
          <tr>
            <td class="detail-label">{{ row.label }}</td>
            <td class="detail-field">
              <ng-container *ngIf="row.controlName === 'leavingFrom'">
                <mat-form-field class="full-width-field">
                  <mat-select [formControlName]="row.controlName" [compareWith]="compareWarehouses">
                    <mat-option *ngFor="let option of warehouseList" [value]="option">
                      {{ option.region }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-container>

              <ng-container *ngIf="row.controlName === 'methodIncoterm'">
                <div class="method-incoterm">
                  <mat-form-field>
                    <mat-select [formControlName]="'freightMethod'" [compareWith]="compareMethods" (selectionChange)="onFreightMethodChange($event.value)">
                      <mat-option *ngFor="let method of methodList" [value]="method">
                        {{ method.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field class="incoterm-field">
                    <mat-select [formControlName]="'incoterm'" [compareWith]="compareIncoterms">
                      <mat-option *ngFor="let incoterm of relevantIncotermList" [value]="incoterm">
                        {{ incoterm.abbreviation }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </ng-container>

              <ng-container *ngIf="row.controlName === 'destinationPort'">
                <mat-form-field class="full-width-field">
                  <textarea cdkTextareaAutosize [formControlName]="row.controlName" matInput readonly></textarea>
                </mat-form-field>
              </ng-container>

              <ng-container *ngIf="row.controlName === 'paymentReceivedBy' || row.controlName === 'dispatchBy' || row.controlName === 'deliveryDate' || row.controlName === 'datePaymentRec'">
                <mat-form-field class="full-width-field">
                  <input [formControlName]="row.controlName" [matDatepicker]="picker" [min]="getMinimumDate(row.controlName)" matInput>
                  <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                  <mat-error *ngIf="proformaForm.get('vsAdditionalDetails.' + row.controlName)?.hasError('dateSequence')">
                    This date cannot precede the previous date.
                  </mat-error>
                  <mat-error *ngIf="proformaForm.get('vsAdditionalDetails.' + row.controlName)?.hasError('defaultDate') || proformaForm.get('vsAdditionalDetails.' + row.controlName)?.hasError('matDatepickerParse')">
                    Enter a date or select Dates To Be Set.
                  </mat-error>
                </mat-form-field>
              </ng-container>

              <ng-container *ngIf="row.controlName === 'proformaReleased' || row.controlName === 'paymentAllocated'">
                <mat-checkbox [formControlName]="row.controlName" color="primary"></mat-checkbox>
              </ng-container>

              <ng-container *ngIf="row.type !== 'date' && row.type !== 'boolean' && row.controlName !== 'leavingFrom' && row.controlName !== 'destinationPort' && row.controlName !== 'methodIncoterm'">
                <mat-form-field [class.currency-field]="row.controlName === 'amountReceived'" class="full-width-field">
                  <span *ngIf="row.controlName === 'amountReceived'" matPrefix>{{ currencySymbol }}&nbsp;</span>
                  <input [formControlName]="row.controlName" [type]="row.type" matInput [attr.step]="row.controlName === 'amountReceived' ? '0.01' : null">
                </mat-form-field>
              </ng-container>
            </td>
          </tr>
          <tr *ngIf="row.controlName === 'incotermLocation' && proformaForm.get('vsAdditionalDetails.incotermLocation')?.hasError('required') && proformaForm.get('vsAdditionalDetails.incotermLocation')?.touched" class="detail-error-row">
            <td colspan="2" class="detail-error" role="alert">
              Enter an Incoterm Location unless the freight method is Virtual.
            </td>
          </tr>
          </ng-container>
        </table>
      </div>
    </div>

    <div class="status-panel panel-block mat-elevation-z1">
      <div class="panel-title panel-title--padded">Dispatch Requirements</div>
      <table class="status-table">
        <tr class="status-heading-row">
          <th>Custom Description</th>
          <th>Release Type</th>
          <th>Freight Terms</th>
        </tr>
        <tr class="status-value-row">
          <td data-label="Custom Description">{{ proformaForm.get('descriptiveType')?.value }}</td>
          <td data-label="Release Type">{{ proformaForm.get('releaseTypeName')?.value }}</td>
          <td data-label="Freight Terms">{{ proformaForm.get('abbreviation')?.value }}</td>
        </tr>
        <tr class="status-heading-row">
          <th scope="col">Country of Origin Required</th>
          <th scope="col">HS Codes Required</th>
          <th scope="col">Inspection Required</th>
        </tr>
        <tr class="status-value-row">
          <td data-label="Country of Origin Required"><mat-icon color="primary">check</mat-icon></td>
          <td data-label="HS Codes Required"><mat-icon color="primary">check</mat-icon></td>
          <td data-label="Inspection Required">
            <mat-icon [color]="proformaForm.get('inspectionRequired')?.value ? 'primary' : 'warn'">
              {{ proformaForm.get('inspectionRequired')?.value ? 'check' : 'close' }}
            </mat-icon>
          </td>
        </tr>
        <tr class="status-heading-row">
          <th scope="col">Show Disclaimer on CI</th>
          <th scope="col">Images Required</th>
          <th scope="col">Split Shipments Required</th>
        </tr>
        <tr class="status-value-row">
          <td data-label="Show Disclaimer on CI">
            <mat-icon [color]="proformaForm.get('showDisclaimerOnCi')?.value ? 'primary' : 'warn'">
              {{ proformaForm.get('showDisclaimerOnCi')?.value ? 'check' : 'close' }}
            </mat-icon>
          </td>
          <td data-label="Images Required">
            <mat-icon [color]="proformaForm.get('imagesRequired')?.value ? 'primary' : 'warn'">
              {{ proformaForm.get('imagesRequired')?.value ? 'check' : 'close' }}
            </mat-icon>
          </td>
          <td data-label="Split Shipments Required">
            <mat-icon [color]="proformaForm.get('splitShipments')?.value ? 'primary' : 'warn'">
              {{ proformaForm.get('splitShipments')?.value ? 'check' : 'close' }}
            </mat-icon>
          </td>
        </tr>
      </table>

      <div class="contact-grid">
        <div class="contact-block">
          <div class="contact-title">Deliver To</div>
          <div class="contact-copy">{{ proformaForm.get('addressDetail')?.value || 'No address selected' }}</div>
        </div>
        <div class="contact-block">
          <div class="contact-title">Notify Party</div>
          <div class="contact-copy">{{ proformaForm.get('preferredAgentFullName')?.value || 'No party selected' }}</div>
        </div>
      </div>

      <div class="contact-grid contact-grid--bottom">
        <div class="contact-block">
          <div class="contact-title">Delivery Contact</div>
          <div class="contact-copy" *ngIf="proformaForm.get('preferredContactFullName')?.value || proformaForm.get('telephone')?.value || proformaForm.get('workEmail')?.value; else noAgent">
            <div><strong>Contact:</strong> {{ proformaForm.get('preferredContactFullName')?.value }}</div>
            <div><strong>Telephone:</strong> {{ proformaForm.get('telephone')?.value }}</div>
            <div><strong>Email:</strong> {{ proformaForm.get('workEmail')?.value }}</div>
          </div>
          <ng-template #noAgent>
            <div class="contact-copy">No agent selected</div>
          </ng-template>
        </div>

        <div class="contact-block">
          <div class="contact-title">Notify Party Contact</div>
          <div class="contact-copy" *ngIf="proformaForm.get('preferredAgentFullName')?.value || proformaForm.get('agentTelephone')?.value || proformaForm.get('agentWorkEmail')?.value; else noAgentNotify">
            <div><strong>Contact:</strong> {{ proformaForm.get('preferredAgentFullName')?.value }}</div>
            <div><strong>Telephone:</strong> {{ proformaForm.get('agentTelephone')?.value }}</div>
            <div><strong>Email:</strong> {{ proformaForm.get('agentWorkEmail')?.value }}</div>
          </div>
          <ng-template #noAgentNotify>
            <div class="contact-copy">No agent selected</div>
          </ng-template>
        </div>
      </div>
    </div>

    <div class="save-bar">
      <div *ngIf="saveStatus !== 'idle'" class="save-status save-status--{{ saveStatus }}" role="status" aria-live="polite">
        <mat-icon *ngIf="saveStatus === 'success'">check_circle</mat-icon>
        <mat-icon *ngIf="saveStatus === 'error'">error</mat-icon>
        <mat-icon *ngIf="saveStatus === 'saving'" class="save-status__spin">sync</mat-icon>
        <span>{{ saveStatusMessage }}</span>
      </div>
      <button class="custom-btn" color="primary" mat-raised-button type="submit" [disabled]="saveStatus === 'saving'">Save</button>
    </div>
  </div>
</form>
